import "./PrivateDriverHireDE.module.css";
import Header from "@/reusable_sections/Header";
import DriverHero from "./sections/DriverHero";
import PrivateDriverHire from "./sections/PrivateDriverHire";
import DurationSelect from "./sections/DurationSelect";
import WhatsIncluded from "./sections/WhatsIncluded";
import UseCases from "./sections/UseCases";
import HowItWorks from "./sections/HowItWorks";
import PopularDestinations from "./sections/PopularDestinations";
import PrivateDriverFaqs from "./sections/PrivateDriverFaqs";
import BookDriver from "./sections/BookDriver";
import Footer from "@/reusable_sections/Footer";
export default function PrivateDriverHireDEPage() {
  return <div>
      <Header />
      <DriverHero />
      <PrivateDriverHire />
      <DurationSelect />
      <WhatsIncluded />
      <UseCases />
      <HowItWorks />
      <PopularDestinations />
      <PrivateDriverFaqs />
      <BookDriver />
      <Footer />
    </div>;
}